import type en from "../en/account";
import type { Messages } from "../../types";

const ar: Messages<typeof en> = {
  // Stores list
  storesTitle: "متاجرك",
  storesDescription: "اختر متجرًا لإدارته، أو أنشئ متجرًا جديدًا.",
  createStore: "إنشاء متجر",
  upgradeToAddStores: "قم بالترقية لإضافة متاجر",
  verifyEmailNotice: "يُرجى تأكيد عنوان بريدك الإلكتروني — أرسلنا رابطًا إلى {email}.",
  resend: "إعادة الإرسال",
  firstStoreTitle: "أنشئ متجرك الأول",
  firstStoreDescription: "لن يستغرق ذلك سوى دقائق. يمكنك إبقاء المتجر خاصًا إلى أن تصبح جاهزًا لنشره.",
  createAStore: "إنشاء متجر",
  currentPlan: "الخطة الحالية",
  managePlan: "إدارة الخطة",

  // New store
  newStoreMeta: "إنشاء متجر",
  welcomeTitle: "مرحبًا بك! لنُعدّ متجرك",
  newStoreTitle: "إنشاء متجر جديد",
  newStoreDescription: "الخطوة 1 من الإعداد — الأساسيات. بعد ذلك ستضيف المنتجات، وتختار طريقة تلقي المدفوعات، ثم تنشر متجرك عندما تكون جاهزًا.",
  storeLimitTitle: "تم بلوغ الحد الأقصى للمتاجر",
  storeLimitBody: "تتيح لك خطة {plan} إنشاء {count} متجر.",
  storeLimitBody_one: "تتيح لك خطة {plan} إنشاء متجر واحد.",
  storeLimitBody_two: "تتيح لك خطة {plan} إنشاء متجرين.",
  storeLimitBody_few: "تتيح لك خطة {plan} إنشاء {count} متاجر.",
  storeLimitBody_many: "تتيح لك خطة {plan} إنشاء {count} متجرًا.",
  seePlans: "عرض الخطط",
  platformSuffixPath: " (على {url}/s/…)",
  biz_general: "تجارة تجزئة عامة",
  biz_fashion: "الأزياء والملابس",
  biz_electronics: "الإلكترونيات",
  biz_beauty: "الجمال ومستحضرات التجميل",
  biz_home: "المنزل والأثاث",
  biz_food: "الأغذية والمنتجات المتخصصة",
  biz_digital: "المنتجات الرقمية",
  biz_services: "الخدمات",
  fieldStoreName: "اسم المتجر",
  changeLaterHint: "يمكنك تغيير ذلك لاحقًا.",
  fieldStoreAddress: "عنوان المتجر",
  slugTaken: "هذا العنوان مستخدم أو محجوز.",
  slugHint: "عنوانك المجاني: {address}. يمكنك ربط نطاقك الخاص لاحقًا.",
  slugPlaceholder: "your-store",
  fieldBusinessType: "ماذا ستبيع؟",
  fieldStoreLanguage: "لغة المتجر",
  fieldCountry: "الدولة",
  fieldStoreCurrency: "عملة المتجر",
  currencyHint: "تُستخدم هذه العملة في الأسعار والطلبات، ولا يمكن تغييرها بعد أول طلب.",
  fieldTimezone: "المنطقة الزمنية",
  fieldTheme: "القالب المبدئي",
  themeHint: "اترك الخيار على «موصى به» لاختيار قالب يناسب نوع نشاطك.",
  themeRecommended: "موصى به",
  themePaidPlans: " (الخطط المدفوعة)",
  creatingStore: "جارٍ إنشاء متجرك…",

  // Account & security
  accountDescription: "أدر ملفك الشخصي وأمان تسجيل الدخول والإشعارات.",
  profile: "الملف الشخصي",
  emailAddress: "عنوان البريد الإلكتروني",
  verified: "مؤكَّد",
  notVerified: "غير مؤكَّد",
  verifiedOn: "تم التأكيد في {date}.",
  verifyPrompt: "أكّد عنوانك لتتمكن من استعادة حسابك وتلقي إشعارات الفوترة. تحقق من بريدك الوارد للعثور على الرابط الذي أرسلناه.",
  resendVerification: "إعادة إرسال رسالة التأكيد",
  sending: "جارٍ الإرسال…",
  changePassword: "تغيير كلمة المرور",
  changePasswordDescription: "يؤدي تغيير كلمة المرور إلى تسجيل خروجك من جميع الأجهزة الأخرى.",
  activeSessions: "الجلسات النشطة",
  activeSessionsDescription: "الأجهزة المسجّل دخولها حاليًا إلى حسابك. سجّل الخروج من أي جهاز لا تتعرف عليه، ثم غيّر كلمة المرور.",
  signOutOthersTitle: "تسجيل الخروج من جميع الجلسات الأخرى؟",
  signOutOthersBody: "سيتعين على كل الأجهزة الأخرى تسجيل الدخول من جديد.",
  signOutOthersConfirm: "تسجيل خروج الأجهزة الأخرى",
  signOutAllOthers: "تسجيل الخروج من جميع الجلسات الأخرى",
  colDevice: "الجهاز",
  colLocation: "الموقع (IP)",
  colSignedIn: "تاريخ تسجيل الدخول",
  colLastActive: "آخر نشاط",
  thisDevice: "هذا الجهاز",
  sessionSignOut: "تسجيل الخروج",
  signingOut: "جارٍ تسجيل الخروج…",
  notifPrefs: "تفضيلات الإشعارات",
  notifPrefsDescription: "اختر إشعارات المتجر التي تريد تلقيها داخل التطبيق. تُرسَل رسائل الفوترة والأمان والدعم دائمًا.",
  closeAccount: "إغلاق الحساب",
  closeAccountDescription: "اطلب من فريقنا إغلاق حسابك على Storelancer.",
  emailHint: "تواصل مع الدعم لتغيير عنوان البريد الإلكتروني المرتبط بحسابك.",
  saveProfile: "حفظ الملف الشخصي",
  currentPassword: "كلمة المرور الحالية",
  newPassword: "كلمة المرور الجديدة",
  confirmNewPassword: "تأكيد كلمة المرور الجديدة",
  passwordHint: "10 أحرف على الأقل، تتضمن حرفًا ورقمًا.",
  changing: "جارٍ التغيير…",
  savePreferences: "حفظ التفضيلات",
  closureReason: "لماذا تغادر؟",
  closureConfirm: "أفهم أن هذا سيرسل طلب إغلاق إلى فريق Storelancer.",
  closureHint: "لا يُحذف أي شيء تلقائيًا. سنتواصل معك أولًا للتأكيد، ونوضح ما سيحدث لمتاجرك وطلباتك واشتراكك.",
  requestClosure: "طلب إغلاق الحساب",
  viewRequest: "عرض طلبك",
  notifGroup_orders: "الطلبات",
  notifGroup_catalog: "الكتالوج",
  notifGroup_payments: "المدفوعات",
  notifGroup_domains: "النطاقات",
  notif_orders_new: "تم تقديم طلب جديد",
  notif_orders_paid: "تم تأكيد دفع الطلب",
  notif_orders_refunded: "تم استرداد مبلغ الطلب",
  notif_orders_return_requested: "تم طلب إرجاع",
  notif_inventory_low_stock: "انخفاض المخزون",
  notif_payments_failed: "فشل الدفع",
  notif_payments_dispute: "فتح نزاع أو استرداد مصرفي",
  notif_payments_connection_problem: "اتصال الدفع يحتاج إلى مراجعة",
  notif_payments_checkout_error: "تعذّر بدء الدفع عند إتمام الشراء",
  notif_payments_mismatch: "عدم تطابق مبلغ الدفع",
  notif_domains_verified: "تم التحقق من النطاق",
  notif_domains_failed: "فشل التحقق من النطاق",
  profileSaved: "تم حفظ الملف الشخصي.",
  prefsSaved: "تم حفظ تفضيلات الإشعارات.",
  sessionEnded: "انتهت جلستك. سجّل الدخول مرة أخرى.",
  newPasswordsDontMatch: "كلمتا المرور الجديدتان غير متطابقتين.",
  passwordsDontMatch: "كلمتا المرور غير متطابقتين",
  chooseStrongerPassword: "اختر كلمة مرور أقوى",
  passwordChanged: "تم تغيير كلمة المرور، وتم تسجيل خروجك من جميع الأجهزة الأخرى.",
  sessionSignedOut: "تم تسجيل الخروج من الجلسة.",
  otherSessionsSignedOut: "تم تسجيل الخروج من جميع الجلسات الأخرى.",
  verificationSent: "تم إرسال رسالة التأكيد إلى {email}.",
  confirmClosure: "يُرجى تأكيد رغبتك في طلب إغلاق الحساب.",
  required: "مطلوب",
  closureSent: "تم إرسال الطلب كتذكرة دعم رقم {number}. سيتواصل معك فريقنا قبل حذف أي شيء.",

  // Notifications
  notificationsDescription: "تحديثات حول متاجرك والفوترة وطلبات الدعم.",
  markAllRead: "تعليم الكل كمقروء",
  unread: "غير المقروءة",
  noUnread: "لا توجد إشعارات غير مقروءة",
  noNotifications: "لا توجد إشعارات بعد",
  notificationsEmpty: "سنُعلمك بالطلبات الجديدة ومشكلات الدفع وعمليات التحقق من النطاقات وردود فريق الدعم.",
  unreadSr: " (غير مقروء)",
  markRead: "تعليم كمقروء",
  notifKind_orders: "الطلبات",
  notifKind_inventory: "المخزون",
  notifKind_payments: "المدفوعات",
  notifKind_domains: "النطاقات",
  notifKind_billing: "الفوترة",
  notifKind_support: "الدعم",
  notifKind_security: "الأمان",
  notifKind_account: "الحساب",
  notifKind_team: "الفريق",
  notifKind_store: "المتجر",
  notifKind_system: "النظام",
  allCaughtUp: "لا يوجد جديد.",
  unknownNotification: "إشعار غير معروف",

  // Billing
  billingDescription: "اشتراكك في Storelancer. وهو منفصل عن المدفوعات التي يجريها عملاؤك في متاجرك، والتي تذهب إلى مزوّد الدفع الخاص بك.",
  checkoutDoneTitle: "شكرًا — اكتملت عملية الدفع",
  checkoutDoneBody: "تُحدَّث خطتك فور تأكيد مزوّد الفوترة لعملية الدفع. يستغرق ذلك عادةً بضع ثوانٍ؛ حدّث الصفحة إذا لم تتغير بعد.",
  planUpdated: "تم تحديث خطتك. تعكس التفاصيل أدناه هذا التغيير.",
  checkoutCancelled: "تم إلغاء عملية الدفع. لم تتغير خطتك.",
  billingUnavailableTitle: "الدفع الإلكتروني للخطط المدفوعة غير متاح بعد",
  billingUnavailableBody: "لم يُعِدّ مشغّل المنصة نظام الفوترة بعد، لذا لا يمكن شراء الخطط المدفوعة من هنا حاليًا. لا يزال بإمكانك التبديل إلى خطة مجانية.",
  contactSupportToUpgrade: "{link} للترقية.",
  contactSupport: "تواصل مع الدعم",
  free: "مجانية",
  pricePerMonth: "{price} شهريًا",
  pricePerYear: "{price} سنويًا",
  perMonthSuffix: " شهريًا",
  orPerYear: "أو {price} سنويًا",
  billing: "الفوترة",
  billedYearly: "فوترة سنوية",
  billedMonthly: "فوترة شهرية",
  noPaymentNeeded: "لا حاجة إلى الدفع",
  assignedByPlatform: "مخصّصة من Storelancer (لا توجد بطاقة مسجّلة)",
  trialEnds: "تنتهي الفترة التجريبية في",
  endsOn: "تنتهي في",
  renewsOn: "تتجدد في",
  movingToPlan: "ستنتقل إلى خطة {plan} في نهاية الفترة الحالية.",
  subscriptionEnding: "سينتهي اشتراكك في نهاية الفترة الحالية.",
  dataKept: "تُحفَظ متاجرك وبياناتك في كلتا الحالتين.",
  pastDue: "فشلت آخر دفعة لاشتراكك. حدّث طريقة الدفع من أحدث فاتورة للاحتفاظ بخطتك.",
  cancelTitle: "إلغاء اشتراكك؟",
  cancelBody: "تحتفظ بخطتك الحالية حتى نهاية فترة الفوترة، ثم تنتقل إلى الخطة المجانية. لا يُحذف أي شيء — إذا تجاوزت حدود الخطة المجانية فلن تتمكن فقط من إضافة المزيد.",
  cancelSubscription: "إلغاء الاشتراك",
  planEnding: "ستنتهي خطتك في نهاية فترة الفوترة الحالية. تُحفَظ بياناتك.",
  usage: "الاستخدام",
  storesYouOwn: "المتاجر التي تملكها",
  perStoreUsage: "يظهر استخدام كل متجر في إعداداته.",
  changePlan: "تغيير الخطة",
  changePlanDescription: "لا يؤدي خفض خطتك أبدًا إلى حذف المتاجر أو المنتجات أو الطلبات. إذا تجاوزت حدًّا ما، فستحتفظ بما لديك لكن لن تتمكن من إضافة المزيد حتى تعود ضمن الحد.",
  switchToTitle: "التبديل إلى خطة {plan}؟",
  switchBodyPaid: "ينتهي اشتراكك المدفوع في نهاية فترة الفوترة الحالية، ثم تنتقل إلى هذه الخطة. لا يُحذف أي شيء.",
  switchBodyFree: "يُطبَّق التغيير فورًا. لا يُحذف أي شيء، لكن لا يمكنك إضافة أكثر مما تسمح به هذه الخطة.",
  switchTo: "التبديل إلى {plan}",
  startingCheckout: "جارٍ بدء الدفع…",
  startTrial: "بدء تجربة لمدة {days} يومًا",
  startTrial_one: "بدء تجربة ليوم واحد",
  startTrial_two: "بدء تجربة ليومين",
  startTrial_few: "بدء تجربة لمدة {days} أيام",
  upgradeMonthly: "ترقية شهرية",
  yearly: "سنويًا",
  invoices: "الفواتير",
  invoicesDescription: "فواتير اشتراكك في Storelancer.",
  noInvoices: "لا توجد فواتير بعد",
  noInvoicesDescription: "تظهر الفواتير هنا بعد أول دفعة لاشتراك مدفوع.",
  colInvoice: "الفاتورة",
  colPeriod: "الفترة",
  colLink: "الرابط",
  invoiceSr: " الفاتورة {number}",

  // Support
  supportDescription: "اطلب المساعدة من فريق Storelancer. نرد هنا وعبر البريد الإلكتروني.",
  yourRequests: "طلباتك",
  noRequests: "لا توجد طلبات دعم بعد",
  noRequestsDescription: "قبل مراسلتنا، قد تجد الإجابة بالفعل في {link}.",
  setupGuides: "أدلة الإعداد",
  colRequest: "الطلب",
  colCategory: "الفئة",
  awaitingReply: "بانتظار ردك",
  newRequest: "طلب جديد",
  cat_general: "سؤال عام",
  cat_billing: "الخطة والفوترة",
  cat_payments: "المدفوعات والتحويلات",
  cat_domains: "النطاقات",
  cat_technical: "مشكلة تقنية",
  cat_account: "الحساب وتسجيل الدخول",
  fieldSubject: "الموضوع",
  fieldCategory: "الفئة",
  fieldStore: "المتجر",
  notAboutStore: "لا يتعلق بمتجر محدد",
  fieldHowCanWeHelp: "كيف يمكننا مساعدتك؟",
  ticketBodyHint: "اذكر ما كنت تتوقعه وما حدث فعلًا. لا تشارك أبدًا كلمات المرور أو مفاتيح API.",
  sendToSupport: "إرسال إلى الدعم",
  fieldYourReply: "ردك",
  sendReply: "إرسال الرد",
  subjectLength: "استخدم من 3 إلى 150 حرفًا",
  bodyLength: "صف المشكلة في 10 أحرف على الأقل",
  checkFields: "يُرجى مراجعة الحقول المميزة.",
  writeMessageFirst: "اكتب رسالة أولًا.",
  replySent: "تم إرسال الرد.",
  ticketMeta: "طلب دعم",
  ticketSummary: "الطلب رقم {number} · {category} · فُتح في {date}",
  requestSent: "تم إرسال طلبك. سنرد هنا ونراسلك على {email}.",
  conversation: "المحادثة",
  supportTeam: "دعم Storelancer",
  you: "أنت",
  requestClosed: "هذا الطلب مغلق",
  reply: "الرد",
  replyReopens: "سيؤدي الرد إلى إعادة فتح الطلب.",

  // Invitations
  inviteMeta: "دعوة إلى متجر",
  homeLink: "الصفحة الرئيسية لـ Storelancer",
  inviteUnavailable: "الدعوة غير متاحة",
  inviteUnavailableDescription: "رابط الدعوة هذا غير صالح أو منتهي الصلاحية أو سبق استخدامه. اطلب من مالك المتجر إرسال دعوة جديدة.",
  goToYourDashboard: "الانتقال إلى لوحة التحكم",
  invitedEyebrow: "لقد تلقيت دعوة",
  joinStore: "انضم إلى {store}",
  invitedAs: "أنت مدعو للمساعدة في إدارة هذا المتجر بصفة",
  invitationFor: "الدعوة موجهة إلى",
  expires: "تنتهي في",
  signInToAcceptHelp: "سجّل الدخول باستخدام {email} لقبول الدعوة. جديد على Storelancer؟ أنشئ حسابًا بهذا البريد الإلكتروني، ثم افتح رابط الدعوة مرة أخرى.",
  signInToAccept: "سجّل الدخول للقبول",
  differentAccount: "حساب مختلف",
  differentAccountBody: "أنت مسجّل الدخول باسم {current}، لكن هذه الدعوة أُرسلت إلى {invited}. سجّل الخروج ثم سجّل الدخول بالعنوان المدعو لقبولها.",
  joining: "جارٍ الانضمام…",
  acceptInvitation: "قبول الدعوة",
  notNow: "ليس الآن",
};

export default ar;
